import CircularProgressBar from "../../../../utils/CircularProgressBar";
import Style from "./Thumb.module.scss";
import { useItemProgressListener } from "@rpldy/uploady";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Assets from "../../../Layouts/Assets";
import StudioAddress from "../../../Dashboard/StudioPreferenceList/Components/StudioAddress";

const validImage = (completed) => (
  <Tooltip id="sucess-tooltip" variant={"warning"}>
    ({Math.ceil(completed)}% uploaded.)
  </Tooltip>
);

export const ProgressBox = ({ data }) => {
  const { completed } = useItemProgressListener(data?.id) || { completed: 0 };

  return (
    <>
      <OverlayTrigger
        placement="top"
        delay={{ show: 100, hide: 80 }}
        overlay={validImage(completed)}
      >
        <figure className={`${Style.file_upload_preview_image}`}>
          <img src={Assets?.image_thumb} alt="image_process" />
        </figure>
      </OverlayTrigger>
      <CircularProgressBar strokeWidth="4" sqSize="30" percentage={completed} />
    </>
  );
};
const Thumb = ({ image, invalid, duplicate }) => {
  const duplicateImage = (props) => (
    <Tooltip
      id="duplicate-tooltip"
      {...props}
      variant={"warning"}
      className={Style.custom_tooltip}
    >
      ({image.count} duplicate found)
    </Tooltip>
  );

  const invalidImage = (props) => (
    <Tooltip
      id="invalid-tooltip"
      {...props}
      variant={"warning"}
      className={Style.toolTip}
    >
      {invalid} (is invalid)
    </Tooltip>
  );
  return (
    <>
      {image?.batchId ? (
        <ProgressBox data={image} />
      ) : image?.duplicate ? (
        <>
          <OverlayTrigger
            placement="top"
            delay={{ show: 100, hide: 80 }}
            overlay={duplicateImage}
          >
            <figure
              className={`${Style.file_upload_preview_image} ${Style.dupliaction} `}
            >
              <img src={Assets?.duplicate_icon} alt="dupe_image" />
              <span className={Style.dupe_name}>
                {image?.count} duplicate found
              </span>
            </figure>
          </OverlayTrigger>
        </>
      ) : (
        <>
          <OverlayTrigger
            placement="top"
            delay={{ show: 100, hide: 80 }}
            overlay={validImage(100)}
          >
            <figure className={`${Style.file_upload_preview_image}`}>
              <img src={image?.src ?? Assets?.image_thumb} alt="thumb image" />
            </figure>
          </OverlayTrigger>

          {image?.src && (
            <div className={Style.success_indicator}>
              <span className={Style.success_check}></span>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Thumb;
